import { render, staticRenderFns } from "./academic_examination_management.vue?vue&type=template&id=02f7ddae&"
import script from "./academic_examination_management.vue?vue&type=script&lang=js&"
export * from "./academic_examination_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports